module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/map-tag-c231179f49baa83cad8751044a1cd6e0.svg&quot;;"